'use strict';
/**
 * Pair that encapsulates the result of an increment in the array.
 */

var _classCallCheck = require("C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var Pair =
/**
 * @param {Object} entry The entry incremented.
 * @param {Number} counter The counter associated to that entry.
 */
function Pair(entry, counter) {
  _classCallCheck(this, Pair);

  this.e = entry;
  this.c = counter;
};

;
module.exports = Pair;